module.exports = {
          srcSet: __webpack_public_path__ + "b756a072777370cbc1f206fc852ecd27-392.png"+" 392w",
          images:[ {path: __webpack_public_path__ + "b756a072777370cbc1f206fc852ecd27-392.png",width: 392,height: 216}],
          src: __webpack_public_path__ + "b756a072777370cbc1f206fc852ecd27-392.png",
          toString:function(){return __webpack_public_path__ + "b756a072777370cbc1f206fc852ecd27-392.png"},
          
          width: 392,
          height: 216
        }